export default "__VITE_ASSET__DNq2CNTP__"